import React from 'react'
import { AssessmentDefs } from 'pages'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'

const Assessments = () => {
    const navigate = useNavigate()

    const goAssessment = (assessmentDef) => {
        const { id } = assessmentDef
        navigate(`${app.audioTranscription}/${id}/`)
    }

    return (
        <AssessmentDefs onSelectAssessment={goAssessment} />
    )
}
export default Assessments